import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: 'InstrumentationKey=4684ffda-1cd8-460e-98ba-08bdd9885f02;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f6bf523f-0016-46c2-a5ee-6467db3b7fbe',
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    enableAutoRouteTracking: true, // Automatically track page views on route changes
    disableFetchTracking: false, // Track API calls
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    autoTrackPageVisitTime: true, // Track time spent on pages
    disableAjaxTracking: false,
    disableTelemetry: false
  }
});

appInsights.loadAppInsights();
appInsights.trackPageView(); // Track initial page view

// Export for custom tracking
export const trackEvent = (name, properties) => {
  appInsights.trackEvent({ name }, properties);
};

export const trackException = (error, properties) => {
  appInsights.trackException({ exception: error }, properties);
};

export const trackMetric = (name, average, properties) => {
  appInsights.trackMetric({ name, average }, properties);
};

export { reactPlugin, appInsights };
export default appInsights;
